import { Avatar, Column, Label } from '@tempmee/react';
import DefaultProfileImage from '~/images/defaultProfileImage.png';

const avatarPx = { '2xl': 80, xl: 64 } as const;

interface IProps {
  profileImage: string;
  size: '2xl' | 'xl';
  showAdminLabel: boolean;
}

export const OfficeAvatar = ({ profileImage, size, showAdminLabel }: IProps) => (
  <Column align="center">
    {profileImage ? (
      <Avatar src={profileImage} size={size} alt="profile image" />
    ) : (
      <img
        src={DefaultProfileImage}
        alt="profile image"
        style={{ width: avatarPx[size], height: avatarPx[size] }}
      />
    )}
    {showAdminLabel && (
      <div style={{ marginTop: -10, alignSelf: 'center', zIndex: 4 }}>
        <Label variant="secondary" appearance="filled" size="sm">
          ADMIN
        </Label>
      </div>
    )}
  </Column>
);
